export const defaultRefundTimeLimit: object = { BIRTHDAY: 'P15D' };
